import * as z from "zod/v4";
import { zCurrency } from "../currency";
import { LandedCostProvider } from "./landed-cost-provider";

const zonosProviderInfoSchema = z.object({
  provider: z.literal(LandedCostProvider.ZONOS),
  quoteId: z.string(),
  orderId: z.string().nullish(),
});
export const ZonosProviderInfoSchema: z.ZodType<ZonosProviderInfo> =
  zonosProviderInfoSchema;
export type ZonosProviderInfo = z.infer<typeof zonosProviderInfoSchema>;

const landedCostProviderInfoSchema = z.discriminatedUnion("provider", [
  zonosProviderInfoSchema,
]);
export const LandedCostProviderInfoSchema: z.ZodType<LandedCostProviderInfo> =
  landedCostProviderInfoSchema;
export type LandedCostProviderInfo = z.infer<
  typeof landedCostProviderInfoSchema
>;

const landedCostTaxIdentifierSchema = z.object({
  type: z.string(),
  value: z.string(),
});
export const LandedCostTaxIdentifierSchema: z.ZodType<LandedCostTaxIdentifier> =
  landedCostTaxIdentifierSchema;
export type LandedCostTaxIdentifier = z.infer<
  typeof landedCostTaxIdentifierSchema
>;

// Redo profit/spread is the redoPerOrderFee - providerOrderFee
const rateLandedCostSchema = z.object({
  providerInfo: LandedCostProviderInfoSchema,
  duties: z.number(), // minor units - the actual landed cost duties that the merchant gets charged
  taxes: z.number(), // minor units - the actual landed cost taxes that the merchant gets charged
  fees: z.number(), // minor units - the actual landed cost fees that the merchant gets charged
  providerOrderFee: z.number(), // minor units — the provider's per-order fee
  redoPerOrderFee: z.number(), // minor units — Redo's per-order fee
  currency: zCurrency,
  inputHash: z.string(),
  taxIdentifiers: z.array(LandedCostTaxIdentifierSchema).nullish(),
  thirdPartyBillingAccount: z.string().nullish(),
});
export const RateLandedCostSchema: z.ZodType<RateLandedCost> =
  rateLandedCostSchema;
export type RateLandedCost = z.infer<typeof rateLandedCostSchema>;
